import { colors } from '_/constants/theme';
import { formatDate } from '_/helpers/formatDate';
import { TFunction } from 'i18next';
import { showMessage } from 'react-native-flash-message';

export const checkinErrorMessage = (error: any, t: TFunction, locale: Locale) => {
  const errorData = error?.response?.data?.data;
  switch (errorData?.type) {
    case 'slotNotAvailable':
      showMessage({
        message: t('error'),
        description: t('qrCodeScreen.errorMessages.slotNotAvailable'),
        backgroundColor: colors.errorRed,
      });
      break;
    case 'SlotAlreadyReserved':
      showMessage({
        message: t('error'),
        description: t('qrCodeScreen.errorMessages.isThereAnotherReservation', {
          endAt: formatDate(new Date(errorData?.currentEventEndAt), 'HH:mm', {
            locale,
          }),
        }),
        backgroundColor: colors.errorRed,
      });
      break;
    case 'checkinAfterEnded':
      showMessage({
        message: t('error'),
        description: t('qrCodeScreen.errorMessages.checkinAfterEnded'),
        backgroundColor: colors.errorRed,
      });
      break;
    case 'checkinAfterTolerance':
      showMessage({
        message: t('error'),
        description: t('qrCodeScreen.errorMessages.checkinAfterTolerance', {
          spaceTolerance: errorData?.spaceTolerance,
        }),
        backgroundColor: colors.errorRed,
      });
      break;
    case 'checkedBeforeAllowedTime':
      showMessage({
        message: t('error'),
        description: t('qrCodeScreen.errorMessages.checkedBeforeAllowedTime', {
          maxEarlyCheckinOffset: errorData?.data,
        }),
        backgroundColor: colors.errorRed,
      });
      break;
    default:
      showMessage({
        message: t('error'),
        description: t('qrCodeScreen.errorMessages.checkinFail'),
        backgroundColor: colors.errorRed,
      });
      break;
  }
};
